import { render, staticRenderFns } from "./EditShareholderCompanyDetails.vue?vue&type=template&id=cc449f08&"
import script from "./EditShareholderCompanyDetails.vue?vue&type=script&lang=js&"
export * from "./EditShareholderCompanyDetails.vue?vue&type=script&lang=js&"
import style0 from "./EditShareholderCompanyDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports